import { useMemo } from 'react'

import { ReportFinancesDataWriteOffStudent } from 'app/dataTypes/reports/data/common/financesSummaryWriteOff'

import {
  ColumnKey,
  columnKeysLeft,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createHeaderCells,
  createDinamicColumnKey,
  columnKeysLeftHeaders,
  createHeaderCellsProps,
  createCellsProps,
  createFooterCellProps,
} from './tableColumns'

export function useStudentsTableData(data: ReportFinancesDataWriteOffStudent, currency: string) {
  const tableData = useMemo(() => {
    const {
      periodType,
      dates,
      items,
      total: { totalByDateIndex, value: totalOverall },
    } = data
    return {
      columnKeysLeft,
      columnKeysLeftHeaders,
      columnKeysRight,
      columnKeysRightHeaders,
      columnKeysMain: createColumnKeysMain(dates),
      columnKeysMainHeaders: createColumnKeysMainHeaders(dates),
      header: createHeaderCells(dates, periodType, currency),
      headerProps: createHeaderCellsProps(dates),
      data: items.map(({ id, studentName, studentClassTitle, valuesByDateIndex, total }, index) => {
        return {
          rowKey: id,
          rowData: dates.reduce(
            (acc, date, index) => {
              const columnKey = createDinamicColumnKey(date)
              acc[columnKey] = { columnKey, value: valuesByDateIndex[index].value }
              return acc
            },
            {
              [ColumnKey.StudentName]: {
                columnKey: ColumnKey.StudentName as const,
                lastRow: index === items.length - 1,
                value: studentName,
              },
              [ColumnKey.StudentClassTitle]: {
                columnKey: ColumnKey.StudentClassTitle as const,
                value: studentClassTitle,
              },
              [ColumnKey.Total]: { columnKey: ColumnKey.Total as const, value: total.value },
            },
          ),
        }
      }),
      dataProps: createCellsProps(dates),
      total: [
        {
          rowKey: 'total',
          rowData: dates.reduce(
            (acc, date, index) => {
              const columnKey = createDinamicColumnKey(date)
              acc[columnKey] = { columnKey, value: totalByDateIndex[index].value }
              return acc
            },
            {
              [ColumnKey.StudentName]: {
                columnKey: ColumnKey.StudentName as const,
                value: '',
              },
              [ColumnKey.StudentClassTitle]: {
                columnKey: ColumnKey.StudentClassTitle as const,
                value: 'ИТОГО',
              },
              [ColumnKey.Total]: {
                columnKey: ColumnKey.Total as const,
                value: totalOverall,
              },
            },
          ),
        },
      ],
      totalProps: createFooterCellProps(dates),
    }
  }, [data, currency])

  return tableData
}
